import { render, staticRenderFns } from "./spinner.mpx?vue&type=template&id=372a87ab&scoped=true&component=true&componentId=spinner7c48ff6a"
import script from "./spinner.mpx?vue&type=script&lang=js&component=true&componentId=spinner7c48ff6a"
export * from "./spinner.mpx?vue&type=script&lang=js&component=true&componentId=spinner7c48ff6a"
import style0 from "./spinner.mpx?vue&type=style&index=0&id=372a87ab&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m7c48ff6a%22%7D&component=true&componentId=spinner7c48ff6a"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372a87ab",
  null
  
)

export default component.exports